export interface TissueAnalogy {
  shortLabel: string;
  fullLabel: string;
  shortFR: string;
  shortEN: string;
  fullFR: string;
  fullEN: string;
  category: "rapide" | "intermediaire" | "lent" | "tres-lent";
}

export function tissueAnalogy(halfTimeMin: number): TissueAnalogy {
  if (halfTimeMin <= 5) {
    return {
      shortLabel: "Sang, SNC",
      fullLabel: "Sang artériel, système nerveux central (perfusion très élevée)",
      shortFR: "Sang, SNC",
      shortEN: "Blood, CNS",
      fullFR: "Sang artériel, système nerveux central (perfusion très élevée)",
      fullEN: "Arterial blood, CNS (very high perfusion)",
      category: "rapide",
    };
  }
  if (halfTimeMin <= 13) {
    return {
      shortLabel: "Cerveau, cœur",
      fullLabel: "Encéphale, cœur, foie, reins (organes très vascularisés)",
      shortFR: "Cerveau, cœur",
      shortEN: "Brain, heart",
      fullFR: "Encéphale, cœur, foie, reins (organes très vascularisés)",
      fullEN: "Brain, heart, liver, kidneys (highly vascular organs)",
      category: "rapide",
    };
  }
  if (halfTimeMin <= 30) {
    return {
      shortLabel: "Muscles, peau",
      fullLabel: "Muscles squelettiques actifs, peau (tissus mous bien perfusés)",
      shortFR: "Muscles, peau",
      shortEN: "Muscles, skin",
      fullFR: "Muscles squelettiques actifs, peau (tissus mous bien perfusés)",
      fullEN: "Active skeletal muscles, skin (well-perfused soft tissues)",
      category: "intermediaire",
    };
  }
  if (halfTimeMin <= 60) {
    return {
      shortLabel: "Articulations",
      fullLabel: "Articulations, intestins, muscles peu sollicités",
      shortFR: "Articulations",
      shortEN: "Joints",
      fullFR: "Articulations, intestins, muscles peu sollicités",
      fullEN: "Joints, intestines, less-active muscles",
      category: "intermediaire",
    };
  }
  if (halfTimeMin <= 120) {
    return {
      shortLabel: "Tissus adipeux",
      fullLabel: "Graisse, tissus adipeux profonds, tendons",
      shortFR: "Tissus adipeux",
      shortEN: "Adipose tissue",
      fullFR: "Graisse, tissus adipeux profonds, tendons",
      fullEN: "Fat, deep adipose tissue, tendons",
      category: "lent",
    };
  }
  if (halfTimeMin <= 250) {
    return {
      shortLabel: "Cartilages",
      fullLabel: "Cartilages, ligaments, moelle épinière",
      shortFR: "Cartilages",
      shortEN: "Cartilage",
      fullFR: "Cartilages, ligaments, moelle épinière",
      fullEN: "Cartilage, ligaments, spinal cord",
      category: "lent",
    };
  }
  if (halfTimeMin <= 450) {
    return {
      shortLabel: "Os spongieux",
      fullLabel: "Os spongieux, tissus conjonctifs denses",
      shortFR: "Os spongieux",
      shortEN: "Spongy bone",
      fullFR: "Os spongieux, tissus conjonctifs denses",
      fullEN: "Spongy bone, dense connective tissues",
      category: "tres-lent",
    };
  }
  return {
    shortLabel: "Os compact",
    fullLabel: "Os compact, tissus à très faible perfusion",
    shortFR: "Os compact",
    shortEN: "Cortical bone",
    fullFR: "Os compact, tissus à très faible perfusion",
    fullEN: "Cortical bone, very low perfusion tissues",
    category: "tres-lent",
  };
}
